import { SVGAttributes } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { IconName } from './types';

export type IconButtonState = 'initial' | 'hover' | 'pressed';

const IconButtonCircle = styled.circle<{ $state: IconButtonState }>`
  stroke-width: 2px;
  ${({ $state }) => {
    switch ($state) {
      case 'initial':
        return css`
          fill: ${colors.white950};
          stroke: ${colors.grey300};
        `;
      case 'hover':
        return css`
          fill: ${colors.grey50};
          stroke: ${colors.grey400};
        `;
      case 'pressed':
        return css`
          fill: ${colors.grey200};
          stroke: ${colors.grey400};
        `;
    }
  }}
`;

type IconButtonArgs = {
  iconName: IconName;
  state: IconButtonState;
  cx?: number;
  cy?: number;
  radius?: number;
  iconSize?: number;
};

export const SvgIconButton = ({
  iconName,
  state,
  cx = 14,
  cy = 14,
  radius = 13,
  iconSize = 20,
  ...rest
}: IconButtonArgs & SVGAttributes<SVGGElement>) => (
  <g style={{ stroke: colors.grey500 }} {...rest}>
    <IconButtonCircle $state={state} cx={cx} cy={cy} r={radius} />
    <svg
      x={cx - iconSize / 2}
      y={cy - iconSize / 2}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <use xlinkHref={`#${iconName}`} />
    </svg>
  </g>
);
